// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomCheckbox-module__font-s-10___YQcV3 {
  font-size: 10px !important;
}

.CustomCheckbox-module__font-s-12___PRc16 {
  font-size: 12px !important;
}

.CustomCheckbox-module__font-s-13___kYUNt {
  font-size: 13px !important;
}

.CustomCheckbox-module__font-s-14___S3e4A {
  font-size: 14px !important;
}

.CustomCheckbox-module__font-s-15___wVllO {
  font-size: 15px !important;
}

.CustomCheckbox-module__font-s-16___nDayC {
  font-size: 16px !important;
}

.CustomCheckbox-module__font-s-18___DsJSr {
  font-size: 18px !important;
}

.CustomCheckbox-module__font-s-20___uQAjp {
  font-size: 20px !important;
}

.CustomCheckbox-module__font-s-22___Cibx2 {
  font-size: 22px !important;
}

.CustomCheckbox-module__font-s-28___xMLi1 {
  font-size: 28px !important;
}

.CustomCheckbox-module__font-w-400___krIhE {
  font-weight: 400 !important;
}

.CustomCheckbox-module__font-w-500___41cM2 {
  font-weight: 500 !important;
}

.CustomCheckbox-module__font-w-600___JLIwB {
  font-weight: 600 !important;
}

.CustomCheckbox-module__font-w-700___gK5B8 {
  font-weight: 700 !important;
}

.CustomCheckbox-module__p-5___QdkEj {
  padding: 5px !important;
}

.CustomCheckbox-module__p-12___ANSqj {
  padding: 12px !important;
}

.CustomCheckbox-module__p-16___x_7lq {
  padding: 16px !important;
}

.CustomCheckbox-module__p-30___Nh6v6 {
  padding: 30px !important;
}

.CustomCheckbox-module__p-b-0___X5bbQ {
  padding-bottom: 0 !important;
}

.CustomCheckbox-module__p-b-5___r2BHi {
  padding-bottom: 5px !important;
}

.CustomCheckbox-module__p-b-10___zMcCx {
  padding-bottom: 10px !important;
}

.CustomCheckbox-module__p-b-12___cjiEP {
  padding-bottom: 12px !important;
}

.CustomCheckbox-module__p-b-16___L7YJq {
  padding-bottom: 16px !important;
}

.CustomCheckbox-module__p-b-18___KEQDl {
  padding-bottom: 18px !important;
}

.CustomCheckbox-module__p-b-20___z9szb {
  padding-bottom: 20px !important;
}

.CustomCheckbox-module__p-b-25___g1YEu {
  padding-bottom: 25px !important;
}

.CustomCheckbox-module__p-b-30___LEtyX {
  padding-bottom: 30px !important;
}

.CustomCheckbox-module__p-b-50___demNP {
  padding-bottom: 50px !important;
}

.CustomCheckbox-module__p-t-0___MZ8v_ {
  padding-top: 0 !important;
}

.CustomCheckbox-module__p-t-12___E618s {
  padding-top: 12px !important;
}

.CustomCheckbox-module__p-t-16___CkYHY {
  padding-top: 16px !important;
}

.CustomCheckbox-module__p-t-18___zF6jz {
  padding-top: 18px !important;
}

.CustomCheckbox-module__p-t-20___DJE5A {
  padding-top: 20px !important;
}

.CustomCheckbox-module__p-t-30___VwqrN {
  padding-top: 30px !important;
}

.CustomCheckbox-module__p-t-40___pwpU5 {
  padding-top: 40px !important;
}

.CustomCheckbox-module__p-t-50___KzPpd {
  padding-top: 50px !important;
}

.CustomCheckbox-module__p-l-20___WYAHm {
  padding-left: 20px !important;
}

.CustomCheckbox-module__p-l-30___of5IZ {
  padding-left: 30px !important;
}

.CustomCheckbox-module__p-l-40___hDiMc {
  padding-left: 40px !important;
}

.CustomCheckbox-module__p-r-16___NAkUy {
  padding-right: 16px !important;
}

.CustomCheckbox-module__p-r-20___egYZq {
  padding-right: 20px !important;
}

.CustomCheckbox-module__p-r-30___doTSy {
  padding-right: 30px !important;
}

.CustomCheckbox-module__p-r-50___F0IrG {
  padding-right: 50px !important;
}

.CustomCheckbox-module__p-r-60___Yu8Og {
  padding-right: 60px !important;
}

.CustomCheckbox-module__m-b-1___b7sya {
  margin-bottom: 1px !important;
}

.CustomCheckbox-module__m-b-2____Je27 {
  margin-bottom: 2px !important;
}

.CustomCheckbox-module__m-b-6___Dses8 {
  margin-bottom: 6px !important;
}

.CustomCheckbox-module__m-b-8____G7zS {
  margin-bottom: 8px !important;
}

.CustomCheckbox-module__m-b-10___VHIuJ {
  margin-bottom: 10px !important;
}

.CustomCheckbox-module__m-b-14___pz7FP {
  margin-bottom: 14px !important;
}

.CustomCheckbox-module__m-b-16___Sjqe8 {
  margin-bottom: 16px !important;
}

.CustomCheckbox-module__m-b-20___VToLq {
  margin-bottom: 20px !important;
}

.CustomCheckbox-module__m-b-22___J67_j {
  margin-bottom: 22px !important;
}

.CustomCheckbox-module__m-b-24___raj72 {
  margin-bottom: 24px !important;
}

.CustomCheckbox-module__m-b-30___CxxgX {
  margin-bottom: 30px !important;
}

.CustomCheckbox-module__m-b-32___J6OEE {
  margin-bottom: 32px !important;
}

.CustomCheckbox-module__m-b-40___xcZ0F {
  margin-bottom: 40px !important;
}

.CustomCheckbox-module__m-t-2___RhbvN {
  margin-top: 2px !important;
}

.CustomCheckbox-module__m-t-3___jAuaK {
  margin-top: 3px !important;
}

.CustomCheckbox-module__m-t-4___cXYYa {
  margin-top: 4px !important;
}

.CustomCheckbox-module__m-t-5___myPG6 {
  margin-top: 5px !important;
}

.CustomCheckbox-module__m-t-8___B1QOB {
  margin-top: 8px !important;
}

.CustomCheckbox-module__m-t-10___Jzykp {
  margin-top: 10px !important;
}

.CustomCheckbox-module__m-t-15___ZpTP9 {
  margin-top: 15px !important;
}

.CustomCheckbox-module__m-t-16___iQmeB {
  margin-top: 16px !important;
}

.CustomCheckbox-module__m-t-20___EzvvU {
  margin-top: 20px !important;
}

.CustomCheckbox-module__m-t-22___KhAVE {
  margin-top: 22px !important;
}

.CustomCheckbox-module__m-t-30___djCBj {
  margin-top: 30px !important;
}

.CustomCheckbox-module__m-t-32___GZAB3 {
  margin-top: 32px !important;
}

.CustomCheckbox-module__m-l-auto___QFBFI {
  margin-left: auto !important;
}

.CustomCheckbox-module__m-l-4___PSGzE {
  margin-left: 4px !important;
}

.CustomCheckbox-module__m-l-5___gwN4l {
  margin-left: 5px !important;
}

.CustomCheckbox-module__m-l-6___WbtfT {
  margin-left: 6px !important;
}

.CustomCheckbox-module__m-l-8___G0d52 {
  margin-left: 8px !important;
}

.CustomCheckbox-module__m-l-10___mcEYm {
  margin-left: 10px !important;
}

.CustomCheckbox-module__m-l-16___x3VpS {
  margin-left: 16px !important;
}

.CustomCheckbox-module__m-l-20___cMCiW {
  margin-left: 20px !important;
}

.CustomCheckbox-module__m-l-24___IKmlZ {
  margin-left: 24px !important;
}

.CustomCheckbox-module__m-l-30___xy7nQ {
  margin-left: 30px !important;
}

.CustomCheckbox-module__m-l-35___PxfZa {
  margin-left: 35px !important;
}

.CustomCheckbox-module__m-l-40____L7_x {
  margin-left: 40px !important;
}

.CustomCheckbox-module__m-r-8___T1Ylw {
  margin-right: 8px !important;
}

.CustomCheckbox-module__m-r-10___hYYj2 {
  margin-right: 10px !important;
}

.CustomCheckbox-module__m-r-16___hIT1r {
  margin-right: 16px !important;
}

.CustomCheckbox-module__m-r-20___AOx4U {
  margin-right: 20px !important;
}

.CustomCheckbox-module__m-r-24___U79CM {
  margin-right: 24px !important;
}

.CustomCheckbox-module__m-r-30___RwDkb {
  margin-right: 30px !important;
}

.CustomCheckbox-module__m-r-40___XWpby {
  margin-right: 40px !important;
}

.CustomCheckbox-module__border-r-3___IX7Nv {
  border-radius: 3px !important;
}

.CustomCheckbox-module__border-r-4___jpzOK {
  border-radius: 4px !important;
}

.CustomCheckbox-module__border-r-6___ultCC {
  border-radius: 6px !important;
}

.CustomCheckbox-module__border-r-10___K4Ybf {
  border-radius: 10px !important;
}

.CustomCheckbox-module__border-r-12___DoUMZ {
  border-radius: 12px !important;
}

.CustomCheckbox-module__border-r-16___GwlxT {
  border-radius: 16px !important;
}

.CustomCheckbox-module__border-r-50___K1w2j {
  border-radius: 50% !important;
}

.CustomCheckbox-module__primary-border___UCN6v {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.CustomCheckbox-module__primary-border-b___dEs3z {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.CustomCheckbox-module__primary-border-t___o0m2U {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.CustomCheckbox-module__primary-border-l___VQW3E {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.CustomCheckbox-module__primary-border-r___uK9XC {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.CustomCheckbox-module__secondary-border___h3kH0 {
  border: 1px solid #637768;
}

.CustomCheckbox-module__secondary-border-b___uUwJl {
  border-bottom: 1px solid #637768;
}

.CustomCheckbox-module__secondary-border-t___xSEMr {
  border-top: 1px solid #637768;
}

.CustomCheckbox-module__secondary-border-l___CBDZI {
  border-left: 1px solid #637768;
}

.CustomCheckbox-module__secondary-border-r___IYVak {
  border-right: 1px solid #637768;
}

.CustomCheckbox-module__gap-0___qH_zh {
  gap: 0 !important;
}

.CustomCheckbox-module__gap-2___bXv6X {
  gap: 2px !important;
}

.CustomCheckbox-module__gap-4___hTWyT {
  gap: 4px !important;
}

.CustomCheckbox-module__gap-5___Eyjra {
  gap: 5px !important;
}

.CustomCheckbox-module__gap-6___eInyp {
  gap: 6px !important;
}

.CustomCheckbox-module__gap-8___Ie1Xu {
  gap: 8px !important;
}

.CustomCheckbox-module__gap-10___uT59i {
  gap: 10px !important;
}

.CustomCheckbox-module__gap-12___AGxRt {
  gap: 12px !important;
}

.CustomCheckbox-module__gap-14___ccrgo {
  gap: 14px !important;
}

.CustomCheckbox-module__gap-16___eN5is {
  gap: 16px !important;
}

.CustomCheckbox-module__gap-18___qzVn8 {
  gap: 18px !important;
}

.CustomCheckbox-module__gap-20___s2trl {
  gap: 20px !important;
}

.CustomCheckbox-module__gap-24___t74yQ {
  gap: 24px !important;
}

.CustomCheckbox-module__gap-26___Apygz {
  gap: 26px !important;
}

.CustomCheckbox-module__gap-30___cjHlx {
  gap: 30px !important;
}

.CustomCheckbox-module__gap-32___uJbz9 {
  gap: 32px !important;
}

.CustomCheckbox-module__gap-40___pcDPD {
  gap: 40px !important;
}

.CustomCheckbox-module__gap-50___Mcd7G {
  gap: 50px !important;
}

.CustomCheckbox-module__flex-1___hllrw {
  flex: 1;
}

.CustomCheckbox-module__flex-none___voLN6 {
  flex: none !important;
}

.CustomCheckbox-module__flex-column___mM6vI {
  display: flex;
  flex-direction: column !important;
}

.CustomCheckbox-module__flex-row____Tar7 {
  display: flex;
  flex-direction: row !important;
}

.CustomCheckbox-module__vertically-centered___lxqLJ {
  display: flex;
  align-items: center !important;
}

.CustomCheckbox-module__horizontally-centered___JwMtj {
  display: flex;
  justify-content: center !important;
}

.CustomCheckbox-module__horizontally-end___Ti9ED {
  display: flex;
  justify-content: end !important;
}

.CustomCheckbox-module__vertically-start___XH74U {
  display: flex;
  align-items: start !important;
}

.CustomCheckbox-module__space-between___h__mB {
  display: flex;
  justify-content: space-between !important;
}

.CustomCheckbox-module__flex-wrap___VSOWk {
  flex-wrap: wrap !important;
}

.CustomCheckbox-module__height-100___cDGPP {
  height: 100%;
}

.CustomCheckbox-module__width-50___y26iO {
  width: 50% !important;
}

.CustomCheckbox-module__width-100___j0aBi {
  width: 100%;
}

.CustomCheckbox-module__cursor-pointer___G6rqk {
  cursor: pointer;
}

.CustomCheckbox-module__cursor-not-allowed___oTZ_t {
  cursor: not-allowed !important;
}

.CustomCheckbox-module__absolute-centered___rAC8v {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.CustomCheckbox-module__absolute___LhqfT {
  position: absolute;
}

.CustomCheckbox-module__relative___rxFk2 {
  position: relative;
}

.CustomCheckbox-module__fixed___jA1Ni {
  position: fixed;
}

.CustomCheckbox-module__visible___iBgLY {
  opacity: 1;
}

.CustomCheckbox-module__invisible___hnKBK {
  opacity: 0;
}

.CustomCheckbox-module__col-90___iauHX {
  width: 90% !important;
}

.CustomCheckbox-module__col-auto___LyXNH {
  width: auto !important;
}

.CustomCheckbox-module__medical-tabs___VDT8d {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.CustomCheckbox-module__medical-table-new___FH7IR {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CustomCheckbox-module__medical-table-new___FH7IR:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CustomCheckbox-module__medical-table-new___FH7IR::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CustomCheckbox-module__medical-table-new___FH7IR::-webkit-scrollbar-track {
  display: none;
}
.CustomCheckbox-module__medical-table-new___FH7IR.CustomCheckbox-module__no-pagination___HBnWP {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CustomCheckbox-module__medical-table-new___FH7IR.CustomCheckbox-module__no-pagination___HBnWP:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CustomCheckbox-module__medical-table-new___FH7IR.CustomCheckbox-module__no-pagination___HBnWP::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CustomCheckbox-module__medical-table-new___FH7IR.CustomCheckbox-module__no-pagination___HBnWP::-webkit-scrollbar-track {
  display: none;
}

.CustomCheckbox-module__medical-table-empty___eUznD {
  padding: 14px 40px !important;
}

.CustomCheckbox-module__icon-btn___uNlXf {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.CustomCheckbox-module__search-icon___krdH4 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.CustomCheckbox-module__disable-select___oPl6G {
  user-select: none;
}

.CustomCheckbox-module__break-word___eWYox {
  word-break: break-word;
}

.CustomCheckbox-module__popup-clear-btn___G54m8 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.CustomCheckbox-module__scroll-m-b-20___4dGOB {
  scroll-margin-bottom: 20px;
}

.CustomCheckbox-module__container___HPQw7 {
  border: 1px solid #375844;
  cursor: pointer;
  padding: 10px;
  position: relative;
}
.CustomCheckbox-module__container___HPQw7.CustomCheckbox-module__checked___ncTvM {
  background-color: #f1f6f2;
}
.CustomCheckbox-module__container___HPQw7.CustomCheckbox-module__disabled___jdFDi {
  cursor: not-allowed;
  opacity: 0.6;
}
.CustomCheckbox-module__container___HPQw7 .CustomCheckbox-module__input___MSfGo {
  position: absolute;
  visibility: hidden;
}

.CustomCheckbox-module__checkbox___TF5ZI {
  border: 1px solid #375844;
  display: inline-block;
  position: relative;
  border-radius: 5px;
  margin-right: 15px;
  min-height: 20px;
  min-width: 20px;
}
.CustomCheckbox-module__checkbox___TF5ZI.CustomCheckbox-module__checked___ncTvM {
  box-shadow: 0 0 0 1px #375844;
}
.CustomCheckbox-module__checkbox___TF5ZI.CustomCheckbox-module__checked___ncTvM .CustomCheckbox-module__check___lZZOT {
  border-right: 2.2px solid #375844;
  border-bottom: 2.2px solid #375844;
  transform: rotate(40deg);
  position: absolute;
  margin-top: 3px;
  width: 4.8px;
  height: 11px;
  content: "";
  right: 6px;
}

.CustomCheckbox-module__loader___LWMgh {
  margin-right: 15px;
}

.CustomCheckbox-module__label___Fwrxz {
  color: #375844;
}

.CustomCheckbox-module__info___w9z7I {
  color: #859989;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/CustomCheckbox/CustomCheckbox.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,yBAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AA8pBF;AA5pBE;EACE,yBAAA;AA8pBJ;AA3pBE;EACE,mBAAA;EACA,YAAA;AA6pBJ;AA1pBE;EACE,kBAAA;EACA,kBAAA;AA4pBJ;;AAxpBA;EACE,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AA2pBF;AAzpBE;EACE,6BAAA;AA2pBJ;AAzpBI;EACE,iCAAA;EACA,kCAAA;EACA,wBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AA2pBN;;AAtpBA;EACE,kBAAA;AAypBF;;AAtpBA;EACE,cAAA;AAypBF;;AAtpBA;EACE,cAAA;AAypBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  border: 1px solid get-color(greenNew, dark);\n  cursor: pointer;\n  padding: 10px;\n  position: relative;\n\n  &.checked {\n    background-color: get-color(greenNew, ultra-light);\n  }\n\n  &.disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n\n  .input {\n    position: absolute;\n    visibility: hidden;\n  }\n}\n\n.checkbox {\n  border: 1px solid get-color(greenNew, dark);\n  display: inline-block;\n  position: relative;\n  border-radius: 5px;\n  margin-right: 15px;\n  min-height: 20px;\n  min-width: 20px;\n\n  &.checked {\n    box-shadow: 0 0 0 1px get-color(greenNew, dark);\n\n    .check {\n      border-right: 2.2px solid get-color(greenNew, dark);\n      border-bottom: 2.2px solid get-color(greenNew, dark);\n      transform: rotate(40deg);\n      position: absolute;\n      margin-top: 3px;\n      width: 4.8px;\n      height: 11px;\n      content: '';\n      right: 6px;\n    }\n  }\n}\n\n.loader {\n  margin-right: 15px;\n}\n\n.label {\n  color: get-color(greenNew, dark);\n}\n\n.info {\n  color: get-color(greenNew, medium);\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `CustomCheckbox-module__font-s-10___YQcV3`,
	"fontS12": `CustomCheckbox-module__font-s-12___PRc16`,
	"fontS13": `CustomCheckbox-module__font-s-13___kYUNt`,
	"fontS14": `CustomCheckbox-module__font-s-14___S3e4A`,
	"fontS15": `CustomCheckbox-module__font-s-15___wVllO`,
	"fontS16": `CustomCheckbox-module__font-s-16___nDayC`,
	"fontS18": `CustomCheckbox-module__font-s-18___DsJSr`,
	"fontS20": `CustomCheckbox-module__font-s-20___uQAjp`,
	"fontS22": `CustomCheckbox-module__font-s-22___Cibx2`,
	"fontS28": `CustomCheckbox-module__font-s-28___xMLi1`,
	"fontW400": `CustomCheckbox-module__font-w-400___krIhE`,
	"fontW500": `CustomCheckbox-module__font-w-500___41cM2`,
	"fontW600": `CustomCheckbox-module__font-w-600___JLIwB`,
	"fontW700": `CustomCheckbox-module__font-w-700___gK5B8`,
	"p5": `CustomCheckbox-module__p-5___QdkEj`,
	"p12": `CustomCheckbox-module__p-12___ANSqj`,
	"p16": `CustomCheckbox-module__p-16___x_7lq`,
	"p30": `CustomCheckbox-module__p-30___Nh6v6`,
	"pB0": `CustomCheckbox-module__p-b-0___X5bbQ`,
	"pB5": `CustomCheckbox-module__p-b-5___r2BHi`,
	"pB10": `CustomCheckbox-module__p-b-10___zMcCx`,
	"pB12": `CustomCheckbox-module__p-b-12___cjiEP`,
	"pB16": `CustomCheckbox-module__p-b-16___L7YJq`,
	"pB18": `CustomCheckbox-module__p-b-18___KEQDl`,
	"pB20": `CustomCheckbox-module__p-b-20___z9szb`,
	"pB25": `CustomCheckbox-module__p-b-25___g1YEu`,
	"pB30": `CustomCheckbox-module__p-b-30___LEtyX`,
	"pB50": `CustomCheckbox-module__p-b-50___demNP`,
	"pT0": `CustomCheckbox-module__p-t-0___MZ8v_`,
	"pT12": `CustomCheckbox-module__p-t-12___E618s`,
	"pT16": `CustomCheckbox-module__p-t-16___CkYHY`,
	"pT18": `CustomCheckbox-module__p-t-18___zF6jz`,
	"pT20": `CustomCheckbox-module__p-t-20___DJE5A`,
	"pT30": `CustomCheckbox-module__p-t-30___VwqrN`,
	"pT40": `CustomCheckbox-module__p-t-40___pwpU5`,
	"pT50": `CustomCheckbox-module__p-t-50___KzPpd`,
	"pL20": `CustomCheckbox-module__p-l-20___WYAHm`,
	"pL30": `CustomCheckbox-module__p-l-30___of5IZ`,
	"pL40": `CustomCheckbox-module__p-l-40___hDiMc`,
	"pR16": `CustomCheckbox-module__p-r-16___NAkUy`,
	"pR20": `CustomCheckbox-module__p-r-20___egYZq`,
	"pR30": `CustomCheckbox-module__p-r-30___doTSy`,
	"pR50": `CustomCheckbox-module__p-r-50___F0IrG`,
	"pR60": `CustomCheckbox-module__p-r-60___Yu8Og`,
	"mB1": `CustomCheckbox-module__m-b-1___b7sya`,
	"mB2": `CustomCheckbox-module__m-b-2____Je27`,
	"mB6": `CustomCheckbox-module__m-b-6___Dses8`,
	"mB8": `CustomCheckbox-module__m-b-8____G7zS`,
	"mB10": `CustomCheckbox-module__m-b-10___VHIuJ`,
	"mB14": `CustomCheckbox-module__m-b-14___pz7FP`,
	"mB16": `CustomCheckbox-module__m-b-16___Sjqe8`,
	"mB20": `CustomCheckbox-module__m-b-20___VToLq`,
	"mB22": `CustomCheckbox-module__m-b-22___J67_j`,
	"mB24": `CustomCheckbox-module__m-b-24___raj72`,
	"mB30": `CustomCheckbox-module__m-b-30___CxxgX`,
	"mB32": `CustomCheckbox-module__m-b-32___J6OEE`,
	"mB40": `CustomCheckbox-module__m-b-40___xcZ0F`,
	"mT2": `CustomCheckbox-module__m-t-2___RhbvN`,
	"mT3": `CustomCheckbox-module__m-t-3___jAuaK`,
	"mT4": `CustomCheckbox-module__m-t-4___cXYYa`,
	"mT5": `CustomCheckbox-module__m-t-5___myPG6`,
	"mT8": `CustomCheckbox-module__m-t-8___B1QOB`,
	"mT10": `CustomCheckbox-module__m-t-10___Jzykp`,
	"mT15": `CustomCheckbox-module__m-t-15___ZpTP9`,
	"mT16": `CustomCheckbox-module__m-t-16___iQmeB`,
	"mT20": `CustomCheckbox-module__m-t-20___EzvvU`,
	"mT22": `CustomCheckbox-module__m-t-22___KhAVE`,
	"mT30": `CustomCheckbox-module__m-t-30___djCBj`,
	"mT32": `CustomCheckbox-module__m-t-32___GZAB3`,
	"mLAuto": `CustomCheckbox-module__m-l-auto___QFBFI`,
	"mL4": `CustomCheckbox-module__m-l-4___PSGzE`,
	"mL5": `CustomCheckbox-module__m-l-5___gwN4l`,
	"mL6": `CustomCheckbox-module__m-l-6___WbtfT`,
	"mL8": `CustomCheckbox-module__m-l-8___G0d52`,
	"mL10": `CustomCheckbox-module__m-l-10___mcEYm`,
	"mL16": `CustomCheckbox-module__m-l-16___x3VpS`,
	"mL20": `CustomCheckbox-module__m-l-20___cMCiW`,
	"mL24": `CustomCheckbox-module__m-l-24___IKmlZ`,
	"mL30": `CustomCheckbox-module__m-l-30___xy7nQ`,
	"mL35": `CustomCheckbox-module__m-l-35___PxfZa`,
	"mL40": `CustomCheckbox-module__m-l-40____L7_x`,
	"mR8": `CustomCheckbox-module__m-r-8___T1Ylw`,
	"mR10": `CustomCheckbox-module__m-r-10___hYYj2`,
	"mR16": `CustomCheckbox-module__m-r-16___hIT1r`,
	"mR20": `CustomCheckbox-module__m-r-20___AOx4U`,
	"mR24": `CustomCheckbox-module__m-r-24___U79CM`,
	"mR30": `CustomCheckbox-module__m-r-30___RwDkb`,
	"mR40": `CustomCheckbox-module__m-r-40___XWpby`,
	"borderR3": `CustomCheckbox-module__border-r-3___IX7Nv`,
	"borderR4": `CustomCheckbox-module__border-r-4___jpzOK`,
	"borderR6": `CustomCheckbox-module__border-r-6___ultCC`,
	"borderR10": `CustomCheckbox-module__border-r-10___K4Ybf`,
	"borderR12": `CustomCheckbox-module__border-r-12___DoUMZ`,
	"borderR16": `CustomCheckbox-module__border-r-16___GwlxT`,
	"borderR50": `CustomCheckbox-module__border-r-50___K1w2j`,
	"primaryBorder": `CustomCheckbox-module__primary-border___UCN6v`,
	"primaryBorderB": `CustomCheckbox-module__primary-border-b___dEs3z`,
	"primaryBorderT": `CustomCheckbox-module__primary-border-t___o0m2U`,
	"primaryBorderL": `CustomCheckbox-module__primary-border-l___VQW3E`,
	"primaryBorderR": `CustomCheckbox-module__primary-border-r___uK9XC`,
	"secondaryBorder": `CustomCheckbox-module__secondary-border___h3kH0`,
	"secondaryBorderB": `CustomCheckbox-module__secondary-border-b___uUwJl`,
	"secondaryBorderT": `CustomCheckbox-module__secondary-border-t___xSEMr`,
	"secondaryBorderL": `CustomCheckbox-module__secondary-border-l___CBDZI`,
	"secondaryBorderR": `CustomCheckbox-module__secondary-border-r___IYVak`,
	"gap0": `CustomCheckbox-module__gap-0___qH_zh`,
	"gap2": `CustomCheckbox-module__gap-2___bXv6X`,
	"gap4": `CustomCheckbox-module__gap-4___hTWyT`,
	"gap5": `CustomCheckbox-module__gap-5___Eyjra`,
	"gap6": `CustomCheckbox-module__gap-6___eInyp`,
	"gap8": `CustomCheckbox-module__gap-8___Ie1Xu`,
	"gap10": `CustomCheckbox-module__gap-10___uT59i`,
	"gap12": `CustomCheckbox-module__gap-12___AGxRt`,
	"gap14": `CustomCheckbox-module__gap-14___ccrgo`,
	"gap16": `CustomCheckbox-module__gap-16___eN5is`,
	"gap18": `CustomCheckbox-module__gap-18___qzVn8`,
	"gap20": `CustomCheckbox-module__gap-20___s2trl`,
	"gap24": `CustomCheckbox-module__gap-24___t74yQ`,
	"gap26": `CustomCheckbox-module__gap-26___Apygz`,
	"gap30": `CustomCheckbox-module__gap-30___cjHlx`,
	"gap32": `CustomCheckbox-module__gap-32___uJbz9`,
	"gap40": `CustomCheckbox-module__gap-40___pcDPD`,
	"gap50": `CustomCheckbox-module__gap-50___Mcd7G`,
	"flex1": `CustomCheckbox-module__flex-1___hllrw`,
	"flexNone": `CustomCheckbox-module__flex-none___voLN6`,
	"flexColumn": `CustomCheckbox-module__flex-column___mM6vI`,
	"flexRow": `CustomCheckbox-module__flex-row____Tar7`,
	"verticallyCentered": `CustomCheckbox-module__vertically-centered___lxqLJ`,
	"horizontallyCentered": `CustomCheckbox-module__horizontally-centered___JwMtj`,
	"horizontallyEnd": `CustomCheckbox-module__horizontally-end___Ti9ED`,
	"verticallyStart": `CustomCheckbox-module__vertically-start___XH74U`,
	"spaceBetween": `CustomCheckbox-module__space-between___h__mB`,
	"flexWrap": `CustomCheckbox-module__flex-wrap___VSOWk`,
	"height100": `CustomCheckbox-module__height-100___cDGPP`,
	"width50": `CustomCheckbox-module__width-50___y26iO`,
	"width100": `CustomCheckbox-module__width-100___j0aBi`,
	"cursorPointer": `CustomCheckbox-module__cursor-pointer___G6rqk`,
	"cursorNotAllowed": `CustomCheckbox-module__cursor-not-allowed___oTZ_t`,
	"absoluteCentered": `CustomCheckbox-module__absolute-centered___rAC8v`,
	"absolute": `CustomCheckbox-module__absolute___LhqfT`,
	"relative": `CustomCheckbox-module__relative___rxFk2`,
	"fixed": `CustomCheckbox-module__fixed___jA1Ni`,
	"visible": `CustomCheckbox-module__visible___iBgLY`,
	"invisible": `CustomCheckbox-module__invisible___hnKBK`,
	"col90": `CustomCheckbox-module__col-90___iauHX`,
	"colAuto": `CustomCheckbox-module__col-auto___LyXNH`,
	"medicalTabs": `CustomCheckbox-module__medical-tabs___VDT8d`,
	"medicalTableNew": `CustomCheckbox-module__medical-table-new___FH7IR`,
	"noPagination": `CustomCheckbox-module__no-pagination___HBnWP`,
	"medicalTableEmpty": `CustomCheckbox-module__medical-table-empty___eUznD`,
	"iconBtn": `CustomCheckbox-module__icon-btn___uNlXf`,
	"searchIcon": `CustomCheckbox-module__search-icon___krdH4`,
	"disableSelect": `CustomCheckbox-module__disable-select___oPl6G`,
	"breakWord": `CustomCheckbox-module__break-word___eWYox`,
	"popupClearBtn": `CustomCheckbox-module__popup-clear-btn___G54m8`,
	"scrollMB20": `CustomCheckbox-module__scroll-m-b-20___4dGOB`,
	"container": `CustomCheckbox-module__container___HPQw7`,
	"checked": `CustomCheckbox-module__checked___ncTvM`,
	"disabled": `CustomCheckbox-module__disabled___jdFDi`,
	"input": `CustomCheckbox-module__input___MSfGo`,
	"checkbox": `CustomCheckbox-module__checkbox___TF5ZI`,
	"check": `CustomCheckbox-module__check___lZZOT`,
	"loader": `CustomCheckbox-module__loader___LWMgh`,
	"label": `CustomCheckbox-module__label___Fwrxz`,
	"info": `CustomCheckbox-module__info___w9z7I`
};
module.exports = ___CSS_LOADER_EXPORT___;
